import { navigateTo } from '@/utils/environment';
import { useInkind } from '@gik/api/inkinds/inkind';
import {
  CheckoutLauncher,
  createCartItemFromProduct,
  productHasIntegratedCheckout,
  productIsTangoCard,
} from '@gik/checkout';
import { CartItem } from '@gik/core/models/gik/Order';
import { Product } from '@gik/core/models/gik/Product';
import { ProductTile, ProductTileDirection } from '@gik/ui';
import React from 'react';

interface IWishlistProductTileProps {
  item: Product;
  inkindRouteId: string;
  toolbar: React.ReactNode;
  direction?: ProductTileDirection;
}

function WishlistProductTile({ item, inkindRouteId, toolbar, direction = 'column' }: IWishlistProductTileProps) {
  const cartItem: CartItem = createCartItemFromProduct(item);
  const hasIntegratedCheckout: boolean = productHasIntegratedCheckout(item);
  const { data: inkindPage } = useInkind(inkindRouteId);
  const wishlistProductUrl = !hasIntegratedCheckout ? `/products/wishlist/${inkindPage?.slug}/${item?.slug}` : null;

  return (
    <CheckoutLauncher
      key={item.id}
      initiatedOn="wishlist"
      cart={[cartItem]}
      cachedProducts={[item]}
      initialInkindRouteId={inkindRouteId}
      child={onClick => (
        <ProductTile
          containImage={productIsTangoCard(item)}
          imageUrl={item.thumbnails[0]}
          onClick={event => (wishlistProductUrl ? navigateTo(wishlistProductUrl) : onClick(event))}
          toolbar={toolbar}
          direction={direction}
          title={item.name}
        />
      )}
    />
  );
}

// never re-render this component as when we remove or add an item to the user's wishlist,
// all the objects that come back will have a different reference even if their value is the same.
export default React.memo(WishlistProductTile, (prevProps, nextProps) => prevProps.toolbar === nextProps.toolbar);
